import React from "react";
import { PolarArea } from "react-chartjs-2";
import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip, Legend, CategoryScale, LinearScale } from "chart.js";
import { transparentize } from "../state/helpers";
import { LifePart } from "../state/LifePart";
import { useScreenSize } from "../contexts/screenSizeContext";

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend, CategoryScale, LinearScale);

function formatLabel(str: string, maxwidth: number): string[] {
    let sections: string[] = [];
    let words = str.split(" ");
    let temp = "";

    words.forEach(function (item, index) {
        if (temp.length > 0) {
            let concat = temp + " " + item;

            if (concat.length > maxwidth) {
                sections.push(temp);
                temp = "";
            } else {
                if (index == words.length - 1) {
                    sections.push(concat);
                    return;
                } else {
                    temp = concat;
                    return;
                }
            }
        }

        if (index == words.length - 1) {
            sections.push(item);
            return;
        }

        if (item.length < maxwidth) {
            temp = item;
        } else {
            sections.push(item);
        }
    });

    return sections;
}

type Props = {
    allMaxValues?: boolean;
    priority?: boolean;
    maxLabelChars?: number;
    selectedRole?: LifePart | null;
    onClick?: (partIndex: number) => void
    roles: LifePart[];
    showLabels?: boolean;
};

export default function Chart({ allMaxValues, maxLabelChars, selectedRole, onClick, roles: propsRoles, showLabels = true }: Props) {
    const allParts = propsRoles;
    const parts = allParts;

    const data = {
        labels: showLabels ? parts.map((p, index) => {
            const text = p.primary ? `!! #${index + 1}\n${p.name}` : `#${index + 1}\n${p.name}`
            return formatLabel(text, maxLabelChars || 30);
        }) : [],
        datasets: [
            {
                label: "Оценка",
                data: parts.map((p) => (allMaxValues ? 10 : p.startpoint)),
                backgroundColor: parts.map((p) => (selectedRole && selectedRole.uuid === p.uuid) ? p.color : transparentize(p.color, selectedRole ? 0.8 : 0.3)),
                borderWidth: 1,
            },
        ],
    };

    const tooltipCallback = (context: any) => {
        const index = context.dataIndex;
        const part = parts[index];
        return part ? part.name : '';
    };
    const screenSize = useScreenSize();
    return (
        <PolarArea
            key={screenSize}
            data={data}
            options={{
                scales: {
                    r: {
                        min: 0,
                        max: 10,
                        pointLabels: {
                            display: showLabels,
                            centerPointLabels: true,
                            font: {
                                size: 14,
                                weight: "bold",
                            },
                        },
                    },
                },
                plugins: {
                    // @ts-ignore: Unreachable code error
                    legend: false,
                    tooltip: {
                        callbacks: {
                            label: tooltipCallback
                        }
                    }
                },
                events: ['mousemove', 'mouseout', 'click'],
                onClick: (event, elements, chart) => {
                    if (onClick && elements[0]) {
                        onClick(elements[0].index)
                    }
                }

            }}
            redraw={false}
        />
    );
}
